/* jshint esversion:11 */
/* jshint loopfunc:true */

document.addEventListener("DOMContentLoaded", function () {
    const widget = document.querySelector(".event-calendar");
    if (!widget) return;

    const daysContainer = widget.querySelector(".event-calendar-days-container");
    const monthEl = widget.querySelector(".month");
    const prevBtn = widget.querySelector(".event-calendar-nav.prev");
    const nextBtn = widget.querySelector(".event-calendar-nav.next");

    const eventsDataEl = document.getElementById("event-data");
    const eventsData = eventsDataEl ? JSON.parse(eventsDataEl.textContent) : {};

    const today = new Date();
    let viewStart = new Date(today);
    const maxDate = new Date(today.getFullYear(), today.getMonth() + 4, 0);

    const responsiveConfig = [
        { minWidth: 1200, days: 7 },
        { minWidth: 992, days: 5 },
        { minWidth: 768, days: 3 },
        { minWidth: 576, days: 2 },
        { minWidth: 0, days: 1 }
    ];

    function getDaysToShow() {
        const width = window.innerWidth;
        for (let config of responsiveConfig) {
            if (width >= config.minWidth) {
                return config.days;
            }
        }
        return 1;
    }

    function formatDate(d) {
        return d.getFullYear() + '-' +
            String(d.getMonth() + 1).padStart(2, '0') + '-' +
            String(d.getDate()).padStart(2, '0');
    }

    function formatTime(dateStr) {
        const date = new Date(dateStr);
        return date.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit', 
            hour12: true 
        });
    }

    function createEventCard(event, isModal = false) {
        const card = document.createElement("div");
        const name = document.createElement("h6");
        const time = document.createElement("p");
   
        name.textContent = event.Name;
        time.textContent = formatTime(event.DateAndTime);

        const description = document.createElement("div");
        description.className = "content";

        if (event.Description) {
            description.innerHTML = event.Description.substring(0, 100) + (event.Description.length > 100 ? '...' : '');
        } else {
            description.textContent = "No description added for this event!";
        }

        const learnMoreLink = document.createElement("a");
        learnMoreLink.href = event.Link || "#";        
        

        if (isModal) {
            const blockWrapper = document.createElement("div");
            const blockOne = document.createElement("div");
            const blockTwo = document.createElement("div");
            const blockLink = document.createElement("div");

            blockWrapper.className = `col row g-0 p-3half`;
            blockOne.className = `col-12 col-md-6 d-flex flex-column justify-content-center`;
            blockTwo.className = `col-12 col-md-6 d-flex align-items-center`;
            blockLink.className = `col-auto px-3half position-relative d-flex align-items-center justify-content-center`;

            card.className = `event-card modal-event-card bg-light-shade mb-1 d-flex align-items-stretch flex-nowrap row g-0`;
            name.className = "h5 mb-0";
            time.className = "mb-half mb-md-0";
            learnMoreLink.className = "text-decoration-none stretched-link";
            learnMoreLink.innerHTML = `<svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.707108 25.457L13.0821 13.082L0.707109 0.707031" stroke="black" stroke-miterlimit="10" stroke-linecap="square"/></svg>`;

            blockOne.appendChild(name);
            blockOne.appendChild(time);
            blockTwo.appendChild(description);
            blockWrapper.appendChild(blockOne);
            blockWrapper.appendChild(blockTwo);
            blockLink.appendChild(learnMoreLink);

            card.appendChild(blockWrapper);
            card.appendChild(blockLink);

        } else {
            card.className = `event-card`;
            name.className = "h5 mb-1";
            time.className = "mb-1";
            learnMoreLink.className = "text-main-shade";
            learnMoreLink.textContent = "Learn More";

            card.appendChild(time);
            card.appendChild(name);
            card.appendChild(learnMoreLink);
        }

        return card;
    }

    function renderDayColumn(date, events) {
        const col = document.createElement("div");
        col.className = "col";

        const dayHeader = document.createElement("div");
        dayHeader.className = "day-header";
        dayHeader.style.cursor = "pointer";
        dayHeader.onclick = () => openModal(date, events);

        const weekday = document.createElement("div");
        weekday.className = "text-uppercase";
        weekday.textContent = date.toLocaleString('default', { weekday: 'short' });

        const dayNum = document.createElement("div");
        dayNum.className = "h3 mb-0 text-primary";
        dayNum.textContent = date.getDate();

        if (date.toDateString() === today.toDateString()) {
            dayHeader.classList.add("today");
        }

        dayHeader.appendChild(weekday);
        dayHeader.appendChild(dayNum);
        col.appendChild(dayHeader);

        const eventsContainer = document.createElement("div");
        eventsContainer.className = "event-container";

        if (events && events.length > 0) {
            const maxVisible = 3;
            const visibleEvents = events.slice(0, maxVisible);

            visibleEvents.forEach(event => {
                eventsContainer.appendChild(createEventCard(event));
            });

            if (events.length > maxVisible) {
                const seeMoreBtn = document.createElement("button");
                seeMoreBtn.type = "button";
                seeMoreBtn.className = "btn btn-link btn-white text-start p-1 w-100 rounded-0 d-flex justify-content-between align-items-center";
                seeMoreBtn.innerHTML = `
                    <span>See ${events.length - maxVisible} more</span>
                    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.707092 9.70703L5.20709 5.20703L0.707092 0.707031" stroke="black" stroke-miterlimit="10" stroke-linecap="square"/></svg>`;
                seeMoreBtn.onclick = (e) => {
                    e.preventDefault();
                    openModal(date, events);
                };
                eventsContainer.appendChild(seeMoreBtn);
            }
        } else {
            const noEvents = document.createElement("p");
            noEvents.className = "text-muted text-center small";
            noEvents.textContent = "No events";
            eventsContainer.appendChild(noEvents);
        }

        col.appendChild(eventsContainer);
        return col;
    }

    function render() {
        const daysToShow = getDaysToShow();
        daysContainer.innerHTML = '';

        const lastVisible = new Date(viewStart);
        lastVisible.setDate(viewStart.getDate() + daysToShow - 1);

        const startMonth = viewStart.getMonth();
        const startYear = viewStart.getFullYear();
        const endMonth = lastVisible.getMonth();
        const endYear = lastVisible.getFullYear();

        if (startMonth === endMonth && startYear === endYear) {
            monthEl.textContent = `${viewStart.toLocaleString('default', { month: 'long' })} ${startYear}`;
        } else {
            const startMonthName = viewStart.toLocaleString('default', { month: 'long' });
            const endMonthName = lastVisible.toLocaleString('default', { month: 'long' });
            monthEl.textContent = `${startMonthName} ${startYear} - ${endMonthName} ${endYear}`;
        }

        for (let i = 0; i < daysToShow; i++) {
            const date = new Date(viewStart);
            date.setDate(viewStart.getDate() + i);

            const dayKey = formatDate(date);
            const dayEvents = eventsData[dayKey] || [];

            daysContainer.appendChild(renderDayColumn(date, dayEvents));
        }

        prevBtn.disabled = viewStart <= today;
        nextBtn.disabled = lastVisible >= maxDate;
    }

    function goPrev() {
        viewStart.setDate(viewStart.getDate() - 1);
        if (viewStart < today) viewStart.setTime(today.getTime());
        render();
    }

    function goNext() {
        viewStart.setDate(viewStart.getDate() + 1);
        
        const daysToShow = getDaysToShow();
        const lastVisible = new Date(viewStart);
        lastVisible.setDate(viewStart.getDate() + daysToShow - 1);
        
        if (lastVisible > maxDate) {
            viewStart.setDate(maxDate.getDate() - daysToShow + 1);
        }
        render();
    }

    let modalDate = null;
    let modalEvents = [];

    function openModal(date, events) {
        modalDate = new Date(date);
        modalEvents = events;
        renderModalContent();
        
        const modalEl = document.getElementById('eventsModal');
        
        if (modalEl.parentElement.tagName !== 'BODY') {
            document.body.appendChild(modalEl);
        }
        
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
    }

    function renderModalContent() {
        const modalTitle = document.getElementById('eventsModalLabel');
        const modalBody = document.getElementById('modal-event-list');

        const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
        modalTitle.textContent = modalDate.toLocaleDateString('default', options);

        modalBody.innerHTML = '';

        if (modalEvents && modalEvents.length > 0) {
            modalEvents.forEach(event => {
                modalBody.appendChild(createEventCard(event, true));
            });
        } else {
            const noEvents = document.createElement("p");
            noEvents.className = "text-muted text-center";
            noEvents.textContent = "No events for this day.";
            modalBody.appendChild(noEvents);
        }

        const prevModalBtn = document.querySelector('.modal-nav-prev');
        const nextModalBtn = document.querySelector('.modal-nav-next');

        prevModalBtn.disabled = modalDate <= today;
        nextModalBtn.disabled = modalDate >= maxDate;
    }

    function modalPrev() {
        modalDate.setDate(modalDate.getDate() - 1);
        if (modalDate < today) modalDate.setTime(today.getTime());
        
        const dayKey = formatDate(modalDate);
        modalEvents = eventsData[dayKey] || [];
        renderModalContent();
    }

    function modalNext() {
        modalDate.setDate(modalDate.getDate() + 1);
        if (modalDate > maxDate) return;
        
        const dayKey = formatDate(modalDate);
        modalEvents = eventsData[dayKey] || [];
        renderModalContent();
    }

    prevBtn.addEventListener("click", (e) => { 
        e.preventDefault(); 
        goPrev(); 
    });

    nextBtn.addEventListener("click", (e) => { 
        e.preventDefault(); 
        goNext(); 
    });

    document.querySelector('.modal-nav-prev').addEventListener("click", (e) => {
        e.preventDefault();
        modalPrev();
    });

    document.querySelector('.modal-nav-next').addEventListener("click", (e) => {
        e.preventDefault();
        modalNext();
    });

    window.addEventListener("resize", render);

    render();
});